export default __webpack_public_path__ + "static/media/events_1.f8b0479f.svg";